import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const PUBLIC_APP_URL = process.env.REACT_APP_PUBLIC_APP_URL || BACKEND_URL;

export const http = axios.create({ baseURL: API });

export function publicUrl(path = "/") {
  const base = PUBLIC_APP_URL.replace(/\/$/, "");
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${base}${cleanPath}`;
}

async function extractErrorDetail(res) {
  let detail = "Anfrage fehlgeschlagen.";
  try {
    const j = await res.json();
    detail = j.detail || detail;
  } catch (e) {
    console.warn("Antwort-JSON konnte nicht gelesen werden:", e);
  }
  const err = new Error(detail);
  err.status = res.status;
  return err;
}

function parseSseEvent(chunk, { onDelta, onDone, onError }) {
  if (!chunk.startsWith("data: ")) return;
  try {
    const ev = JSON.parse(chunk.slice(6));
    if (ev.type === "delta") onDelta(ev.content);
    else if (ev.type === "done") onDone(ev);
    else if (ev.type === "error") onError(ev.message);
  } catch (e) {
    console.warn("SSE-Event konnte nicht geparst werden:", e);
  }
}

function buildFormData({ deviceId, sessionId, message, mode, sensorData, files }) {
  const fd = new FormData();
  fd.append("device_id", deviceId);
  if (sessionId) fd.append("session_id", sessionId);
  fd.append("message", message);
  fd.append("mode", mode);
  if (sensorData) fd.append("sensor_data", JSON.stringify(sensorData));
  (files || []).forEach((f) => fd.append("files", f));
  return fd;
}

export async function streamChat(opts) {
  const { onDelta, onDone, onError } = opts;
  const res = await fetch(`${API}/chat`, { method: "POST", body: buildFormData(opts) });
  if (!res.ok) throw await extractErrorDetail(res);

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) >= 0) {
      const chunk = buffer.slice(0, idx).trim();
      buffer = buffer.slice(idx + 2);
      parseSseEvent(chunk, { onDelta, onDone, onError });
    }
  }
}
